<div mat-dialog-draggable-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
	<a class="float-right btnClose" (click)="cerrarPopup()"><i class="fal fa-times" style="cursor: pointer;"></i></a>
	<a class="float-right btnClose" (click)="maximizarPopup()"><i class="fal fa-window-maximize"></i></a>
	<a class="float-right btnClose" (click)="minimizarPopup()"><i class="fal fa-window-minimize"></i></a>
	<div style="margin:0 auto; text-align: center;">
		<div class="matTitulo">
			<i class="fal fa-file-search" id="ico"></i>
			<h1 class="titulo" style="display:inline-block;">Estadísticas del Dispositivo</h1>
		</div>
	</div>
</div>
<div class="kt-portlet">
	<div class="kt-portlet__body">
		<div class="kt-section">
			<div class="kt-section__content">
				<div class="contenedor-modal">
					<div class="data-grid">
						<div class="row">
							<div class="col col-sm-12 col-md-12 col-lg-12 descripcion">
								<span>Análisis estadístico de la velocidad máxima y promedio de la operación del
									vehículo con el económico: <b>{{vehiculoInfo.economico}}</b></span>
							</div>
						</div>
						<div class="row mt-3" *ngIf="minimoChar" id="velocidades">
							<div class="col col-sm-6 col-md-6 col-lg-6">
								<dx-circular-gauge id="gauge" [value]="promedio">
									<dxo-scale [startValue]="0" [endValue]="150" [tickInterval]="10">
										<dxo-label [customizeText]="velocidades"></dxo-label>
									</dxo-scale>
									<dxo-range-container>
										<dxi-range [startValue]="0" [endValue]="50" color="#228B22"></dxi-range>
										<dxi-range [startValue]="50" [endValue]="100" color="#FFD700"></dxi-range>
										<dxi-range [startValue]="100" [endValue]="150" color="#CE2029"></dxi-range>
									</dxo-range-container>
									<dxo-title text="Velocidad Promedio">
										<dxo-font [size]="28"></dxo-font>
									</dxo-title>
								</dx-circular-gauge>
							</div>
							<div class="col col-sm-6 col-md-6 col-lg-6">
								<dx-circular-gauge id="gauge" [value]="maximochar">
									<dxo-scale [startValue]="0" [endValue]="150" [tickInterval]="10">
										<dxo-label [customizeText]="velocidades"></dxo-label>
									</dxo-scale>
									<dxo-range-container>
										<dxi-range [startValue]="0" [endValue]="50" color="#228B22"></dxi-range>
										<dxi-range [startValue]="50" [endValue]="100" color="#FFD700"></dxi-range>
										<dxi-range [startValue]="100" [endValue]="150" color="#CE2029"></dxi-range>
									</dxo-range-container>
									<dxo-title text="Velocidad Máxima">
										<dxo-font [size]="28"></dxo-font>
									</dxo-title>
								</dx-circular-gauge>
							</div>
							<mat-divider class="mt-3"></mat-divider>
							<div class="col col-sm-12 col-md-12 col-lg-12" id="recorrido">
								<dx-linear-gauge id="distancia" [value]="totalDistance" [subvalues]="totalDistance">
									<dxo-value-indicator type="rangebar" color="#46be8a">
									</dxo-value-indicator>
									<dxo-scale [startValue]="0" [endValue]="totalDistance + 10"
										[tickInterval]="intervalo">
										<dxo-label [customizeText]="distancia"></dxo-label>
									</dxo-scale>
									<dxo-title [text]="tituloRecorrido">
										<dxo-font [size]="28"></dxo-font>
									</dxo-title>
								</dx-linear-gauge>
							</div>
						</div>
						<div class="row mt-3">
							<div class="col col-sm-12 col-md-12 col-lg-12" style="text-align: right;">
								<button class="btnPopup pdf" mat-raised-button (click)="imprimirGrafica()"><i
										id="btnIco" class="fas fa-file-pdf"></i>&nbsp;Generar PDF</button>&nbsp;
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<dx-load-panel #loadPanel shadingColor="rgba(0,0,0,0.4)" [position]="{ of: '#char-content' }"
	[(visible)]="loadingVisible" [showIndicator]="true" [showPane]="true" [shading]="true"
	[closeOnOutsideClick]="false">
</dx-load-panel>
